module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Website-w720.41a46994.jpg";